export default __webpack_public_path__ + "static/media/White-uploadVDO.fcf75208.svg";